module.exports = __webpack_public_path__ + "img/station@2x.8ca5d895.png";